export default __webpack_public_path__ + "static/media/prevNew.3216c72d.svg";